import AgnosticFormController from 'root/main/components/forms/core/agnosticFormController';
import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';

export default function (els) {
    if (els) {
        try {
            /* in case the form was loaded on a page ( not in a lightbox ) we want to make sure that multiple forms can exist on the same page
             * If it was loaded on a page then the argument that has been passed to the dynamically loaded form, should be a NodeList
             * */
            if (els.length > 0 && els instanceof NodeList) {
                Array.from(els).forEach(el => {
                    const agnosticForm = new AgnosticFormController(el);
                    agnosticForm.init();
                });
            } else {
                /* if it is a single element and not a NodeList it means the form has be loaded in a lightbox
                 * where we are passing only the form element as an argument to the dynamically loaded form
                 * in the lightboxFormInit.js under the formLightboxCallback
                 */
                const agnosticForm = new AgnosticFormController(els);
                agnosticForm.init();
            }
        } catch (e) {
            LoggingHandler().logError(e, {
                searchTerm: 'agnostic-form-load-init-error',
                tags: ['forms'],
                fileName: 'agnosticFormControllerInit.js',
                additionalData: {
                    url: window.location.href,
                },
            });
        }
    }
}
